export const ShippingAddressData = [
  {
    Address:
      "Suite 2, Wesley Hall, Barrack Road, AlderShot,Hampire United Kingdom, GU11 MNP",
  },
];
